import {LucideFlame} from "lucide-react";

export const ProductShowcase = () => {

    const header = "MILITAIRE KWALITEIT";
    const description = "Ontworpen voor betrouwbaarheid wanneer alle andere methodes falen.";

    return (
        <section id="producten" className="py-24 bg-ink-900 border-t border-ink-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-ember-400 mb-3">
                        Onze producten
                    </span>
                    <h2 className="font-display font-bold uppercase text-4xl lg:text-5xl text-ink-50 mb-4">
                        {header}
                    </h2>
                    <p className="text-xl text-ink-300 max-w-3xl mx-auto">
                        {description}
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {ProductItemData.map(x =>
                        <ProductItem
                            key={x.bolcomUrl}
                            title={x.title}
                            price={x.price}
                            feature={x.feature}
                            imageUrl={x.imageUrl}
                            bolcomUrl={x.bolcomUrl}
                            isBestSeller={x.isBestSeller}
                        />)
                    }
                </div>
            </div>
        </section>
    );
};

const baseBolUrl = "https://www.bol.com/nl/nl/p/";

interface ProductItemProps {
    title: string;
    price: string;
    feature: string;
    imageUrl: string;
    bolcomUrl: string;
    isBestSeller: boolean;
}

const ProductItemData: ProductItemProps[] = [
    {
        title : "Kompas",
        price : "10,99",
        feature : "Licht gewicht met kompas",
        imageUrl : "fs1-sfeer-1.jpg",
        bolcomUrl : "fire-strike-magnesium-stick-vuurstarter-magnesium-staaf-vonken-maker-survival-3-in-1-strijker-magnesiumstaaf-met-kompas-zwart/9300000035386976",
        isBestSeller : false
    },
    {
        title: "Rond",
        price: "16,99",
        feature: "Veel strikes, robuust design.",
        imageUrl: "fs2-sfeer-1.jpg",
        bolcomUrl : "fire-strike-magnesium-staaf-vuur-maker-magnesium-stick-vuurstarter-vonken-maker-survival-3-in-1-strijker-magnesiumstaaf-zwart-groen/9300000056996419",
        isBestSeller: true
    },
    {
        title: "Hexagon",
        price: "19,99",
        feature: "Nog makkelijker schrapen door hexagon vorm.",
        imageUrl: "fs3-sfeer-1.jpg",
        bolcomUrl : "fire-strike-hexagon-magnesium-staaf-vuur-maker-magnesium-stick-vuurstarter-vonken-maker-survival-3-in-1-strijker-magnesiumstaaf-zwart-bruin/9300000083166883",
        isBestSeller: false
    },
]

const ProductItem = (props: ProductItemProps) => {
    return (
        <div className="group relative flex flex-col bg-ink-800 rounded-2xl overflow-hidden border border-ink-700
                        hover:border-ember-500/50 hover:shadow-ember transition-all duration-300">
            {props.isBestSeller && <BestSellerBadge />}

            <div className="relative h-56 overflow-hidden">
                <img
                    src={`/img/${props.imageUrl}`}
                    alt={`Fire Strike ${props.title} magnesium vuurstarter`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-900/70 to-transparent" />
            </div>

            <div className="flex flex-col flex-1 p-6">
                <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-ink-50">
                    {props.title}
                </h3>

                <p className="mt-2 text-ink-300 text-sm flex-1">
                    {props.feature}
                </p>

                <div className="mt-6 flex items-center justify-between">
                    <span className="text-3xl font-bold text-ink-50">
                        €{props.price}
                    </span>

                    <button
                        onClick={() => window.open(`${baseBolUrl + props.bolcomUrl}`, '_blank')}
                        className="inline-flex items-center gap-2 bg-fire-gradient text-white px-5 py-2.5 rounded-lg
                                   font-semibold shadow-ember-sm hover:brightness-110 hover:scale-[1.02] transition-all"
                    >
                        <LucideFlame className="h-4 w-4" />
                        Bestel
                    </button>
                </div>
            </div>
        </div>
    );
};

const BestSellerBadge = () => {
    return (
        <div className="absolute top-4 left-4 z-10 bg-fire-gradient text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide shadow-ember-sm">
            Bestverkocht
        </div>
    );
};
